import { render, staticRenderFns } from "./TeamAlt.vue?vue&type=template&id=9ba1c940"
import script from "./TeamAlt.vue?vue&type=script&lang=ts"
export * from "./TeamAlt.vue?vue&type=script&lang=ts"
import style0 from "./TeamAlt.vue?vue&type=style&index=0&id=9ba1c940&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports